const idRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9]{4,}$/; // 영문자가 반드시 포함되고, 숫자가 있을 수 있으며 4자리 이상인 아이디를 체크하는 정규식
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,32}$/; // (알파벳, 숫자, 특수문자를 각 1개씩 포함하고 8~32자리)
const phoneRegex = /^(01[0-9])-(\d{3,4})-(\d{4})$/; //  휴대폰 번호 정규 표현식
const companyPhoneRegex = /^(02|0[3-9]\d{1}|01[0-9])-(\d{3,4})-(\d{4})$/; // 서울, 기타 지역번호, 휴대폰 번호 정규 표현식

// 아이디 유효성 검사 함수
export const isValidateId = (id: string) => {
  // 아이디가 숫자로만 구성되어 있지 않은지 추가로 검사
  const isNotOnlyNumbers = !/^\d+$/.test(id);
  return idRegex.test(id) && isNotOnlyNumbers;
};
// 이메일 형식 검증 함수
export const isValidateEmail = (email: string) => {
  return emailRegex.test(email);
};
// 비밀번호 유효성 검사 (알파벳, 숫자, 특수문자를 각 1개씩 포함하고 8~32자리)
export const isValidatePassword = (password: string) => {
  return passwordRegex.test(password);
};
export function isValidPhoneNumber(phoneNumber: string) {
  return phoneRegex.test(phoneNumber);
}
export function isValidCompanyPhoneNumber(companyPhoneNumber: string) {
  return companyPhoneRegex.test(companyPhoneNumber);
}

export function formatPhoneNumber(phoneNumber: string) {
  // 전화번호에서 숫자만 남기기 (숫자가 아닌 문자는 모두 제거)
  phoneNumber = phoneNumber.replace(/\D/g, '');

  // 전화번호가 010으로 시작하는 경우 (11자리)
  if (/^010/.test(phoneNumber)) {
    // 010으로 시작, 11자리
    if (phoneNumber.length === 11) {
      const result = phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      return result;
      // 초과 길이 잘라내기
    } else if (phoneNumber.length > 11) {
      phoneNumber = phoneNumber.slice(0, 11);
      const result = phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      return result;
    } else {
      return phoneNumber;
    }
  }
  // 전화번호가 011, 016, 017, 018, 019로 시작하는 경우 (10자리)
  else if (/^01[1|6|7|8|9]/.test(phoneNumber)) {
    if (phoneNumber.length === 10) {
      const result = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      return result;
    } else if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.slice(0, 10);
      const result = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      return result;
    } else {
      return phoneNumber;
    }
  }
  // 다른 경우는 입력된 값 그대로 반환
  else {
    return phoneNumber;
  }
}
export function formatCompanyPhoneNumber(companyPhoneNumber: string) {
  // 전화번호에서 숫자만 남기기 (숫자가 아닌 문자는 모두 제거)
  companyPhoneNumber = companyPhoneNumber.replace(/\D/g, '');
  // 회사 연락처 포맷팅
  if (/^02/.test(companyPhoneNumber)) {
    // 서울 번호 02로 시작
    if (companyPhoneNumber.length === 9) {
      return companyPhoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    if (companyPhoneNumber.length === 10) {
      return companyPhoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    if (companyPhoneNumber.length > 10) {
      companyPhoneNumber = companyPhoneNumber.slice(0, 10);
      return companyPhoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    return companyPhoneNumber;
  } else if (/^0[3-9]/.test(companyPhoneNumber)) {
    // 지역 번호 03x, 04x, ..., 09x로 시작
    if (companyPhoneNumber.length === 10) {
      return companyPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    if (companyPhoneNumber.length === 11) {
      return companyPhoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    if (companyPhoneNumber.length > 11) {
      companyPhoneNumber = companyPhoneNumber.slice(0, 11);
      return companyPhoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    return companyPhoneNumber;
  }

  // 기타 번호 (길이에 따라 포맷)
  if (companyPhoneNumber.length === 10) {
    return companyPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }
  if (companyPhoneNumber.length === 11) {
    return companyPhoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  // 포맷 불가능한 경우 입력된 값 그대로 반환
  return companyPhoneNumber;
}
